import {Inject, Injectable} from "@angular/core";
import {BehaviorSubject, Subject} from "rxjs";
import {ProductService} from "../product/product.service";
import {ExchangeService} from "../exchange/exchange.service";
import {CurrencyService} from "../currency/currency.service";
import {WalletControllerService} from "@aparraga/ahoracrypto-api-sdk/sdk/api/walletController.service";
import {IS_BROWSER} from "../utils/injectiontokens";
import {NavigationService} from "../navigation/navigation.service";
import {LocalStorageService} from "../storage/local-storage.service";

@Injectable({
  providedIn: 'root'
})
export class CryptoService {

  //initialize by default to bitcoin
  public currentCrypto: any = null;
  public currentNetwork: any = null;
  public currentCryptoNetworks: any = [];

  protected currentSymbol = 'BTC';

  public cryptoSubject$: Subject<any> = new BehaviorSubject<any>(null);
  public networkSubject$: Subject<any> = new BehaviorSubject<any>(null);

  constructor(@Inject(IS_BROWSER) protected isBrowser: boolean,
              protected currencyService: CurrencyService,
              protected walletControllerService: WalletControllerService,
              protected navigationService: NavigationService,
              protected exchangeService: ExchangeService,
              protected productService: ProductService,
              protected storageService: LocalStorageService) {

    if(this.isBrowser) {
      const crypto = this.storageService.getObject<any>("crypto");
      if (crypto != null && crypto.baseCurrency) {
        this.currentSymbol = crypto.baseCurrency;
      }
    }

    this.navigationService.queryParams$.subscribe(queryParams => {
      //check if queryParams contains crypto:
      if(queryParams != null && queryParams['crypto'] != null) {
        this.currentSymbol = queryParams['crypto'].toUpperCase();
      }
    });

    this.exchangeService.exchangePricesSubject$.subscribe(exchangePrices => {
      if (this.currentCrypto == null) {
        let price = this.exchangeService.getExchangePrice(this.currentSymbol, this.currencyService.getSelectedCurrency()?.code);
        this.setSelectedCrypto(price);
      } else {
        let price = this.exchangeService.getExchangePrice(this.currentCrypto.baseCurrency, this.currencyService.getSelectedCurrency()?.code);
        this.setSelectedCrypto(price);
      }
    });

    this.cryptoSubject$.subscribe(crypto => {
      if(crypto != null) {
        this.loadNetworks(crypto).then(networks => {
          let network = null;
          if (this.isBrowser) {
            network = this.storageService.getObject<any>(`network-${crypto.baseCurrency}`);
          }
          if (network == null) {
            network = this.getDefaultNetwork(networks);
          }
          if (network != null) {
            this.setSelectedNetwork(network, false);
          }
          this.saveData();
        });
      }
    });

  }

  public setSelectedCrypto(crypto) {
    if(crypto != null) {
      this.currentCrypto = crypto;
      this.productService.getProduct(crypto.baseCurrency).then(product => {
        this.currentCrypto.listable = product.listable;
      });
      this.cryptoSubject$.next(this.currentCrypto);
    }
  }

  public getDefaultNetwork(networks) {
    let returnValue = null;
    networks.forEach(network => {
      if (network.default) {
        returnValue = network;
      }
    });
    if (returnValue == null) {
      returnValue = networks[0];
    }
    return returnValue;
  }

  public getDefaultNetworkForCurrentCrypto() {
    return this.getDefaultNetwork(this.getAvailableNetworksForCurrentCrypto());
  }

  protected loadNetworks(crypto: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.walletControllerService.walletControllerGetNetworks(crypto.baseCurrency).subscribe(result => {
        let networks = result[0];
        if (networks.length > 0) {
          this.currentCryptoNetworks = networks;
          // if no default network is found, get the first one
          resolve(networks);
        }
        else {
          reject("No networks found for this cryptocurrency");
        }
      },
      error => {
        reject(error);
      });
    });

  }

  public getAvailableNetworksForCurrentCrypto() {
    return this.currentCryptoNetworks;
  }

  public setSelectedNetwork(network: any, saveData = true) {
    this.currentNetwork = network;
    this.networkSubject$.next(this.currentNetwork);
    if(saveData) {
      this.saveData();
    }
  }

  public getSelectedCrypto(): any {
    return this.currentCrypto;
  }

  public getSelectedNetwork(): any {
    return this.currentNetwork;
  }

  public saveData() {
    if(this.isBrowser) {
      this.storageService.setObject('crypto', this.currentCrypto);
      this.storageService.setObject(`network-${this.currentCrypto.baseCurrency}`, this.currentNetwork);
    }
  }

  public async getCryptocurrencyName(symbol: string) {
    let returnValue = null;
    let product = await this.productService.getProduct(symbol);
    if(product != null) {
      returnValue = product.name;
    }
    return returnValue;
  }

  public getPeggedCurrency(symbol: string) {
    if (symbol == "USDT" ||
      symbol == "BUSD" ||
      symbol == "USDC" ||
      symbol == "DAI" ||
      symbol == "TUSD" ||
      symbol == "USDP" ||
      symbol == "USDN" ||
      symbol == 'USDD') {
      return 'USD';
    }
    else {
      return symbol;
    }

  }


}
